var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPaperCircled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.507812 22.2832C0.507812 10.1329 10.3575 0.283203 22.5078 0.283203C34.6581 0.283203 44.5078 10.1329 44.5078 22.2832C44.5078 34.4335 34.6581 44.2832 22.5078 44.2832C10.3575 44.2832 0.507812 34.4335 0.507812 22.2832ZM40.5078 22.2832C40.5078 12.3421 32.4489 4.2832 22.5078 4.2832C12.5667 4.2832 4.50781 12.3421 4.50781 22.2832C4.50781 32.2243 12.5667 40.2832 22.5078 40.2832C32.4489 40.2832 40.5078 32.2243 40.5078 22.2832Z",
    fill: "#C7C5C5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1329_28749",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.507812 22.2832C0.507812 10.1329 10.3575 0.283203 22.5078 0.283203C34.6581 0.283203 44.5078 10.1329 44.5078 22.2832C44.5078 34.4335 34.6581 44.2832 22.5078 44.2832C10.3575 44.2832 0.507812 34.4335 0.507812 22.2832ZM40.5078 22.2832C40.5078 12.3421 32.4489 4.2832 22.5078 4.2832C12.5667 4.2832 4.50781 12.3421 4.50781 22.2832C4.50781 32.2243 12.5667 40.2832 22.5078 40.2832C32.4489 40.2832 40.5078 32.2243 40.5078 22.2832Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1329_28749)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.508 -6V22.2833C22.508 22.2833 10.9799 40.5751 9.48037 47.6368C7.98085 54.6984 15.9999 52.9319 15.9999 52.9319L44.508 38.5472L50.4619 22.2833L44.9288 4.23679L22.508 -6Z",
    fill: "#DC0037"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0602 28.0601H21.8601V29.2601H17.0602V28.0601Z",
    fill: "#131010"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4602 25.66H17.0602V26.86H25.4602V25.66Z",
    fill: "#131010"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0602 23.26H23.0602V24.46H17.0602V23.26Z",
    fill: "#131010"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6602 14.14C14.6602 13.18 15.4344 12.46 16.4602 12.46H23.7883L28.9402 17.6113V29.86C28.9402 30.82 28.1659 31.54 27.1402 31.54H16.4602C15.5016 31.54 14.6602 30.7552 14.6602 29.86V14.14ZM26.8915 17.26L24.2602 14.6281V17.26H26.8915ZM15.8602 29.86C15.8602 30.0976 16.163 30.34 16.4602 30.34H27.1402C27.4987 30.34 27.7402 30.147 27.7402 29.86V18.46H23.0602V13.66H16.4602C16.1002 13.66 15.8602 13.852 15.8602 14.14V29.86Z",
    fill: "#131010"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1402 18.46V29.14H31.3402V18.46H30.1402Z",
    fill: "#131010"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1402 30.34H31.3402V31.54H30.1402V30.34Z",
    fill: "#131010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaperCircled);
export default __webpack_public_path__ + "static/media/icon-paper-circled.c6db42fd0718b39a2834a41dc8a1d9bf.svg";
export { ForwardRef as ReactComponent };